import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PopupService } from '../../../../../services/popup.service';
import { PropertyService } from '../../../../../services/property.service';
import { LoaderService } from '../../../../../services/loader.service';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../../../../environments/environment';
import { RemovedItemsService } from "../../../../../services/removed-items.service";
import {MyStuffService} from "../../../../../services/my-stuff.service";

@Component({
  selector: 'app-removed-properties',
  templateUrl: './removed-properties.component.html',
  styleUrls: ['./removed-properties.component.less']
})
export class RemovedPropertiesComponent implements OnInit {
  propertiesContainerElement: any;
  propertiesInputElement: any;

  constructor(public popupService: PopupService, public propertyService: PropertyService,
    public ref: ChangeDetectorRef, public loaderService : LoaderService, public removedItemsService : RemovedItemsService, public myStuffService : MyStuffService) { }

  ngOnInit() {
    if(this.popupService.popupList.popups['my-stuff'] && !this.myStuffService.myStuffSectionOpened.deletedProperties) {
      this.removedItemsService.fetchRemovedPropertiesSource.next(true);
      this.myStuffService.myStuffSectionOpened.deletedProperties = true;      
    }
  }

  ngAfterViewInit() {
    this.removedItemsService.removedPropertiesAddInputEventObservable();
  }

  paginate() {
    this.removedItemsService.fetchDeletedProperties();
  }
  addBackDeletedItem(item) {
    item.itemType = 'property';
    this.myStuffService.addBackDeletedItem(item);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/popups/my-stuff/removed-items/removed-properties/removed-properties.component.ts